import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { VrboReservationAlterationDialogComponent } from './vrbo-reservation-alteration-dialog.component'

@Injectable()
export class VrboReservationAlterationDialogService {
  constructor(private dialog: MatDialog) {}

  open(inquiry: Inquiry) {
    let defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { inquiry },
    }

    return this.dialog.open(VrboReservationAlterationDialogComponent, defaultConfig)
  }
}
